import { useRef } from 'react';
import { useClickAway } from 'react-use';
import { XMarkIcon } from '@heroicons/react/24/outline';

export const SimpleModal = ({ hideModal, children }) => {
  const ref = useRef();
  useClickAway(ref, hideModal);
  return (
    <div className="fixed top-0 left-0 z-100 h-screen w-screen bg-gray-200/50 backdrop-blur-[2px]">
      <div
        ref={ref}
        className="absolute top-1/2 left-1/2 w-3/4 -translate-x-1/2 -translate-y-1/2 rounded-xl border-gray-200 bg-white shadow-md lg:w-1/2"
      >
        <XMarkIcon className="absolute top-0 right-0 size-18 p-4 hover:cursor-pointer" onClick={hideModal}></XMarkIcon>
        <div className="p-20">{children}</div>
      </div>
    </div>
  );
};
